import React from 'react';
import OrdersIndex from 'src/routes/Companies/OrdersIndex';

export function CompanyOrders() {
  // TODO: either move OrdersIndex in Company directory or delete CompanyOrders component
  return <OrdersIndex />;
}
